<template>
  <div class="financial-view">
    <app-header icon="bell" title="Notificações Push"></app-header>

    <section>
      <b-loading :active.sync="isLoading" :is-full-page="false"></b-loading>
      <div class="card">
        <div class="card-header">
          <div class="card-header-title">Configurar Notificação</div>
        </div>
        <div class="card-content">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label">Título</label>
                <div class="control">
                  <input v-model="title" class="input" type="text" placeholder="Título da notificação" maxlength="50" />
                </div>
              </div>

              <div class="field">
                <label class="label">Mensagem</label>
                <div class="control">
                  <app-input type="textarea" :maxLength="280" :hasCounter="true" placeholder="Digite a mensagem..."
                    tooltipPosition="is-bottom" v-model="message"></app-input>
                </div>
              </div>

              <div class="field">
                <b-checkbox v-model="openLink">
                  Adicionar Link de Ação
                </b-checkbox>
              </div>

              <div v-if="openLink" class="field">
                <label class="label">URL do Link</label>
                <div class="control">
                  <input 
                    v-model="link" 
                    class="input" 
                    type="url" 
                    placeholder="https://exemplo.com"
                  >
                  <p v-if="isVisibleInvalidUrl" class="help is-danger">
                    URL inválida
                  </p>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="box">
                <h4 class="title is-5">Pré-visualização</h4>
                <div class="content">
                  <p>
                    <strong>Título:</strong> {{ title || 'Nova Notificação' }}
                  </p>
                  <p><strong>Mensagem:</strong> {{ message || '...' }}</p>
                  <p v-if="openLink && link">
                    <strong>Link: </strong>
                    <a :href="link" target="_blank">{{ link }}</a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="card-header-buttons">
            <b-tooltip 
              label="Preencha o título e a mensagem para habilitar" 
              position="is-bottom" 
              :active="!isFormValid"
            >
              <b-button 
                @click="openConfirmationModal" 
                :disabled="!isFormValid" 
                type="is-primary"
                icon-left="paper-plane"
              >
                Enviar Notificação
              </b-button>
            </b-tooltip>
            <b-button @click="clearData" type="is-warning" class="ml-2">
              Limpar Campos
            </b-button>
          </div>
        </div>
      </div>
    </section>

    <b-modal v-model="isConfirmationModalActive" has-modal-card trap-focus>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirmar Envio</p>
        </header>
        <section class="modal-card-body">
          <notification-preview :title="title" :message="message" :link="link" :open-link="openLink">
          </notification-preview>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="isConfirmationModalActive = false">Cancelar</b-button>
          <b-button @click="confirmSend" type="is-primary">Confirmar Envio</b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PushNotifications from '../services/push-notifications.service';
import NotificationPreview from '../components/NotificationPreview.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    NotificationPreview,
  },

  data() {
    return {
      page: 1,
      perPage: 10,
      isLoading: false,
      title: '',
      message: '',
      link: '',
      openLink: false,
      isConfirmationModalActive: false,
    };
  },

  computed: {
    isFormValid() {
      return (
        this.message.trim() &&
        this.title.trim() &&
        (!this.openLink || (this.openLink && this.isValidUrl))
      );
    },

    isValidUrl() {
      try {
        new URL(this.link);
        return true;
      } catch {
        return false;
      }
    },
    ...mapGetters(['clinicId', 'userType', 'permissions']),

    isVisibleInvalidUrl() {
      return this.openLink && this.link && !this.isValidUrl;
    }
  },

  watch: {
  },

  async mounted() {
    if (this.isCooldownActive) this.startCountdown();
  },

  beforeDestroy() {
    this.stopCountdown();
  },

  methods: {
    async confirmSend() {
      this.isConfirmationModalActive = false;
      this.isLoading = true;

      try {
        const payload = {
          title: this.title,
          body: this.message,
          data: {
            open_link: this.openLink,
            ...(this.openLink && { link: this.link }),
          },
        };

        await PushNotifications.send(payload);

        this.$buefy.snackbar.open({
          message: 'Notificação enviada',
          type: 'is-success',
          position: 'is-top',
          duration: 5000,
        });

        this.clearData();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    openConfirmationModal() {
      if (this.openLink && !this.isValidUrl) {
        this.$buefy.snackbar.open({
          message: 'URL inválida para o link',
          type: 'is-warning',
        });
        return;
      }
      this.isConfirmationModalActive = true;
    },
    clearData() {
      this.title = '';
      this.message = '';
      this.link = '';
      this.openLink = false;
    },
    handleError(error) {
      const message =
        error.response?.data?.message || 'Erro ao enviar notificação';
      this.$buefy.snackbar.open({ message, type: 'is-danger' });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-header-buttons {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

.box {
  margin-top: 1rem;
  background: #f8f9fa;
}
</style>
